import { type Metadata } from "next";
import { INCLUSO_WEBSITE_URL } from "~/content/value";
import { metadataConfig } from "./metadataConfig";

export const getMetadata = (
  path: string | number,
  customBaseTitle?: string,
): Metadata => {
  const metadata = metadataConfig[path];
  return metadata
    ? {
        title: `${metadata.title} | Incluso`,
        description: metadata.description,
        alternates: { canonical: INCLUSO_WEBSITE_URL + metadata.canonicalLink },
      }
    : {
        title: `${customBaseTitle ?? "NDIS Services Australia | Plan Review & Registration | Incluso"}`,
        description: `Find NDIS services Australia across Sydney, Melbourne and Adelaide. We’re your go-to NDIS service provider for NDIS plan renewal, NDIS review and to find NDIS support workers.`,
        alternates: { canonical: INCLUSO_WEBSITE_URL + "/" },
      };
};
